export default __webpack_public_path__ + "static/media/598.a614c2ff.gif";